"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _default = function _default() {
  return (0, _preact.h)("svg", {
    "enable-background": "new 0 0 213.1 213.1",
    viewBox: "0 0 213.1 213.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, (0, _preact.h)("circle", {
    cx: "106.6",
    cy: "106.6",
    fill: "#ffcc4d",
    r: "106.6"
  }), (0, _preact.h)("circle", {
    cx: "59.5",
    cy: "94.4",
    fill: "#212121",
    r: "10.1"
  }), (0, _preact.h)("circle", {
    cx: "153.6",
    cy: "94.7",
    fill: "#212121",
    r: "10.1"
  }), (0, _preact.h)("g", {
    fill: "#231f20"
  }, (0, _preact.h)("path", {
    d: "m71.4 138.8h70.4"
  }), (0, _preact.h)("path", {
    d: "m141.8 143.8h-70.4c-2.8 0-5-2.2-5-5s2.2-5 5-5h70.4c2.8 0 5 2.2 5 5s-2.3 5-5 5z"
  })));
};

exports.default = _default;